import {
    FieldConfig, isNegativeNumber,
    SkyNetSpreadSheetCellType, SkyNetSpreadSheetConfigType,
} from 'app/shared-components/SkyNetSpreadSheet'
import {
    ContractCurrency, OtherFeesAllowed,
    FeeChargeability, ProductType,
} from 'app/enums/label.enums'
import {
    OtherLaneFeesTable,
} from '../OtherLaneFees.types'

export default function OtherLaneFeesSpreadsheetConfig({
    getLabel,
    getAllowedValues,
}: {
    getLabel: (s: string) => string,
    getAllowedValues: (type: Record<string, string>) => Record<string, string>,
}): SkyNetSpreadSheetConfigType<keyof OtherLaneFeesTable> {
    const fields: FieldConfig<keyof OtherLaneFeesTable>[] = [
        {
            name: 'feeName',
            title: getLabel('LaneFeesRateCard.feeName'),
            cellConfig: {
                type: SkyNetSpreadSheetCellType.SELECT,
            },
            width: 200,
            allowedValues: getAllowedValues(OtherFeesAllowed),
            noneOption: false,
            disabled: true,
        },
        {
            name: 'feeChargability',
            title: getLabel('LaneFeesRateCard.feeChargability'),
            cellConfig: {
                type: SkyNetSpreadSheetCellType.SELECT,
            },
            width: 200,
            allowedValues: getAllowedValues(FeeChargeability),
            noneOption: false,
            disabled: true,
        },
        {
            name: 'productType',
            title: getLabel('LaneFeesRateCard.productType'),
            cellConfig: {
                type: SkyNetSpreadSheetCellType.SELECT,
            },
            width: 100,
            allowedValues: getAllowedValues(ProductType),
            noneOption: false,
            disabled: true,
        },
        {
            name: 'description',
            title: getLabel('LaneFeesRateCard.description'),
            width: 400,
            required: true,
            cellConfig: {
                type: SkyNetSpreadSheetCellType.TEXT,
            },
        },
        {
            name: 'currency',
            title: getLabel('LaneFeesRateCard.currency'),
            cellConfig: {
                type: SkyNetSpreadSheetCellType.SELECT,
            },
            width: 80,
            allowedValues: getAllowedValues(ContractCurrency),
            noneOption: false,
            disabled: true,
        },
        {
            name: 'feeValue',
            title: getLabel('LaneFeesRateCard.feeValue'),
            width: 100,
            required: true,
            cellConfig: {
                type: SkyNetSpreadSheetCellType.NUMBER,
                validate: isNegativeNumber('feeValue'),
            },
        },
        {
            name: 'id',
            width: 1,
            hidden: true,
            cellConfig: {
                type: SkyNetSpreadSheetCellType.ID,
            },
        },
    ]

    return {
        id: 'OtherLaneFees',
        title: 'Other Standard Lane Fees',
        headerRow: true,
        rowsCounter: true,
        headerHeight: 60,
        addRowMenuOption: false,
        enableRangeSelection: true,
        enableRowSelection: true,
        stickyTopRows: 1,
        filterable: true,
        rowsLimit: 25,
        emptyRows: 0,
        initialFocusLocation: {
            columnId: 'feeName',
            rowId: 0,
        },
        fields,
    }
}
